import { Row } from '@tanstack/react-table';
import {
  DisplayPreArrivalFormField,
  PreArrivalFormFields,
} from 'pages/automations/preArrivalForm/PreArrivalFormTab.types';
import CheckboxField from 'components/forms/checkboxField/CheckboxField';

const StatusCell = ({ row }: { row: Row<DisplayPreArrivalFormField> }) => {
  const { id } = row.original;

  const isFieldDisabled =
    id === PreArrivalFormFields.PRIMARY_GUEST_FIRST_NAME ||
    id === PreArrivalFormFields.PRIMARY_GUEST_LAST_NAME;

  return <CheckboxField name={`${id}.isActive`} disabled={isFieldDisabled} />;
};

export default StatusCell;
